import { render, staticRenderFns } from "./VolunteergiftsDetail.vue?vue&type=template&id=b3e36bce&scoped=true"
import script from "./VolunteergiftsDetail.vue?vue&type=script&lang=js"
export * from "./VolunteergiftsDetail.vue?vue&type=script&lang=js"
import style0 from "./VolunteergiftsDetail.vue?vue&type=style&index=0&id=b3e36bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e36bce",
  null
  
)

export default component.exports